export default "__VITE_ASSET__DxDFRNgw__"